import * as yup from 'yup';

const initialValues = {
  username: localStorage.getItem('userId') || '',
  password: '',
  rememberMe: !!localStorage.getItem('userId'),
};

const validationSchema = yup.object().shape({
  username: yup.string().required('Username is required.'),
  password: yup.string().required('Password is required.'),
  rememberMe: yup.boolean(),
});

export { initialValues, validationSchema };
